import {cloneDeep, get} from 'lodash';
import {getArray, getNumber, getString} from "Core/helpers/data";
import {
	StatisticsChartSeriesDataObject,
	StatisticsChartSeriesItemDataObject, StatisticsCircularChartDataObject,
	StatisticsDataObject,
	StatisticsValueDataObject
} from "Components/advanced/Statistics/dataObjects";
import {getDate, STANDARD_DATE_TIME_FORMAT} from "Core/helpers/datetime";
import {STATISTICS_TYPE} from "Components/advanced/Statistics/const";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @param {StatisticsType} statisticsType - Statistics type.
 * @return {StatisticsDataObject}
 */
export const input = (rawData, statisticsType) => {
	let result = cloneDeep(rawData);

	result = new StatisticsDataObject(
		getString(result, 'type'),
		getArray(result, 'individualData').map(i => new StatisticsValueDataObject(
			getString(i, 'name'), getNumber(i, 'count')
		)),
		(
			[
				STATISTICS_TYPE.THERAPISTS_THERAPIST_VISITS,
				STATISTICS_TYPE.THERAPISTS_THERAPIST_PATIENTS
			].includes(statisticsType) ?
				getArray(result, 'chartData').map(i => new StatisticsCircularChartDataObject(
					getString(i, 'id'), getString(i, 'label'), getNumber(i, 'value'), getString(i, 'color'),
				))
				:
				getArray(result, 'chartData').map(i => new StatisticsChartSeriesDataObject(
					getString(i, 'id'),
					getArray(i, 'data').map(j => new StatisticsChartSeriesItemDataObject(
						(
							[
								STATISTICS_TYPE.THERAPISTS_DAILY_VISITS,
								STATISTICS_TYPE.THERAPISTS_DAILY_DIFFERENT_PATIENTS
							].includes(statisticsType) ?
								getDate(getString(j, 'x'), STANDARD_DATE_TIME_FORMAT.ISO_DATE)
								: [
									STATISTICS_TYPE.THERAPISTS_MONTHLY_VISITS,
									STATISTICS_TYPE.THERAPISTS_MONTHLY_DIFFERENT_PATIENTS
								].includes(statisticsType) ?
									getDate(getString(j, 'x'), 'yyyy-M')
								: [
									STATISTICS_TYPE.THERAPISTS_YEARLY_VISITS,
									STATISTICS_TYPE.THERAPISTS_YEARLY_DIFFERENT_PATIENTS
								].includes(statisticsType) ?
									getDate(getString(j, 'x'), 'yyyy')
								:
								get(j, 'x')
						),
						getNumber(j, 'y'),
						get(j, 'color')
					))
				))
		)
	);

	return result;
}

// @note There is no output function since statistics are read only.